import React, { useState, useEffect, useCallback } from 'react';
import PowerIconLarge from '../../../assets/img/dashboard/iconPowerLarge';
import PowerIcon from '../../../assets/img/dashboard/powerLarge';

const RelayType = ({selectedItem, handlePower}) => {

	const [power, setPower] = useState();
	useEffect(() => {
		if(selectedItem.deviceType === "RelayController" || selectedItem.deviceType === "RelayController2" || selectedItem.deviceType === "RelayControllerDc" || selectedItem.deviceType === "RelayControllerDc2"){
			setPower(selectedItem.deviceState.power1)
		}else{
			setPower(selectedItem.deviceState.power)
		}
		
	},[selectedItem, power]);

	const handleRelayPower = () => {
		handlePower(selectedItem);
		setPower(!power);
	}
    
    const getActiveClassName = useCallback(() => {
        return power ? "device-button" : "device-button deactive";
    }, [power]);
	return (
		<>
			<section key={selectedItem.id + "relay"} className="device-setting-body relay-wrap">
				<div className="device-display relay">
					<div className={power ? "display active" : "display"}>
						<p className={"icon-power-large"}><PowerIconLarge/></p>
						<p>켜짐</p>
					</div>
				</div>
				<div className="device-control-wrap" />
			</section>
			<section className="device-setting-footer">
				<div className={getActiveClassName()}>
						<button onClick={handleRelayPower}>
							<PowerIcon/> 전원
						</button>
				</div>
			</section>
	</>
	);
}

export default RelayType;